import { Dispatch, SetStateAction, useMemo } from 'react'

import { useAppSelector } from '~/redux/hooks'

import Boss from '~/bootcamp/components/Quiz/Boss'

import { selectBossIsBusy, selectHasStartedQuiz } from '~/bootcamp/slices/bootcamp-quiz.slice'

import BossMobileModal from '~/bootcamp/components/Quiz/BossMobileModal'
import { BossBattleEnemy } from '~/bootcamp/components/Quiz/QuizProps.models'

const QuizBoss = ({
  vccTitle,
  showOnModal,
  setShowSplashScreen,
  bossBattleEnemy,
}: {
  vccTitle: string
  showOnModal: boolean
  setShowSplashScreen: Dispatch<SetStateAction<boolean>>
  bossBattleEnemy: BossBattleEnemy
}): React.ReactElement => {
  const hasStartedQuiz = useAppSelector(selectHasStartedQuiz)
  const showBossAnimation = useAppSelector(selectBossIsBusy)
  const showBoss = (!hasStartedQuiz ? true : showBossAnimation) ?? false

  const bossClassName = useMemo(() => {
    if (showOnModal) {
      return showBoss ? 'opacity-1 z-20' : 'opacity-0 pointer-events-none'
    }

    return hasStartedQuiz ? 'absolute top-10 pointer-events-none' : 'mx-auto mt-3 relative'
  }, [hasStartedQuiz, showOnModal, showBoss])

  return (
    <BossMobileModal showModal={(hasStartedQuiz && showBossAnimation && showOnModal) ?? false}>
      <Boss
        bossBattleEnemy={bossBattleEnemy}
        className={`absolute transition duration-500 self-center w-full h-full ${bossClassName}`}
        setShowSplashScreen={setShowSplashScreen}
        showBoss={showBoss}
        subjectName={vccTitle}
      />
    </BossMobileModal>
  )
}

export default QuizBoss
